import React from "react";
import { Header, Table, TableProps } from "@amzn/awsui-components-console";
import {
  FixedFeeConfig,
  TaCPeriod,
} from "@amzn/fuse-accounting-central-datastore-client";

interface Props {
  fixedFeeConfig: FixedFeeConfig;
}

const DUMMY_COLUMN_DEFINITION = {
  id: "",
  header: "",
  cell: () => "",
};

// Helper function to format numeric values
const formatNumber = (value: any) => {
  if (!value) return "-";
  return Number(value.string).toLocaleString("en-US", {
    maximumFractionDigits: 4,
  });
};

export const TacBreakdownTable: React.FC<Props> = ({ fixedFeeConfig }) => {
  if (
    !fixedFeeConfig.tacBreakdown ||
    Object.keys(fixedFeeConfig.tacBreakdown).length === 0
  ) {
    return null;
  }

  const contractCurrencyCode = fixedFeeConfig.contractCurrencyCode;

  // TODO: add column for fetching the transaction
  const tacPeriodColumnDefinitions: TableProps.ColumnDefinition<TaCPeriod>[] = [
    DUMMY_COLUMN_DEFINITION,
    {
      id: "periodStartDate",
      header: "Period Start Date",
      cell: (item: TaCPeriod) => item.periodStartDate,
    },
    {
      id: "periodEndDate",
      header: "Period End Date",
      cell: (item: TaCPeriod) => item.periodEndDate,
    },
    {
      id: "serviceEndDate",
      header: "Service End Date",
      cell: (item: TaCPeriod) => item.serviceEndDate,
    },
    {
      id: "issuanceAmount",
      header: `Issuance Amount (${contractCurrencyCode})`,
      cell: (item: TaCPeriod) => formatNumber(item.issuanceAmount),
    },
    {
      id: "amortizationDays",
      header: "Amortization Days",
      cell: (item: TaCPeriod) => item.amortizationDays,
    },
    DUMMY_COLUMN_DEFINITION,
  ];

  const tacBreakdownData = Object.values(fixedFeeConfig.tacBreakdown).sort(
    (a, b) => (a.periodStartDate ?? "").localeCompare(b.periodStartDate ?? ""),
  );

  return (
    <Table
      columnDefinitions={tacPeriodColumnDefinitions}
      items={tacBreakdownData}
      wrapLines={false}
      resizableColumns={false}
      header={
        <Header
          counter={`(${Object.entries(fixedFeeConfig.tacBreakdown).length})`}
        >
          TaC Breakdown
        </Header>
      }
    />
  );
};
